// Vessel group data from Global Fishing Watch workspaces
// Updated: Feb 6, 2026

export const vesselGroups = {
  gulfMenhaden: {
    id: 'gulf-menhaden',
    name: 'Gulf Menhaden Reduction Vessels',
    description: 'Industrial menhaden reduction vessels operating in the Gulf of Mexico',
    color: '#F59E0B',
    icon: '⚙️',
    vessels: [
      { mmsi: '366986130', imo: '7237195', name: 'Timbalier Bay', flag: 'USA' },
      { mmsi: '366986140', imo: '7201677', name: 'Grand Calliou', flag: 'USA' },
      { mmsi: '366986160', imo: '7308023', name: 'Qo Dunn', flag: 'USA' },
      { mmsi: '367002630', imo: '7309467', name: 'Tiger Point', flag: 'USA' },
      { mmsi: '367088130', imo: '7207853', name: 'Oyster Bayou', flag: 'USA' },
      { mmsi: '367088150', imo: '7534816', name: 'Mississippi Sound', flag: 'USA' },
      { mmsi: '367088160', imo: '7534787', name: 'Gussie Flynn', flag: 'USA' },
      { mmsi: '367088170', imo: '7802720', name: 'Bulldog', flag: 'USA' },
      { mmsi: '367088180', imo: '7643291', name: 'Grande Batture', flag: 'USA' },
      { mmsi: '367088190', imo: '7316472', name: 'Willard P Lebeouf', flag: 'USA' },
      { mmsi: '367088210', imo: '7308061', name: 'Rachel Burton', flag: 'USA' },
      { mmsi: '367088240', imo: '7048934', name: 'Albert J Bourg', flag: 'USA' },
      { mmsi: '367088290', imo: '7048960', name: 'Frosty Morn', flag: 'USA' },
      { mmsi: '367088340', imo: '7237183', name: 'Atchafalaya Bay', flag: 'USA' },
      { mmsi: '367088350', imo: '7742449', name: 'Grand Cheniere', flag: 'USA' },
      { mmsi: '367108790', imo: '7902087', name: 'Isle Derniere', flag: 'USA' },
      { mmsi: '367108840', imo: '7201536', name: 'Galveston Bay', flag: 'USA' },
      { mmsi: '367108850', imo: '7100677', name: 'Cote Blanche Bay', flag: 'USA' },
      { mmsi: '367108910', imo: '7207839', name: 'Marsh Island', flag: 'USA' },
      { mmsi: '367108920', imo: '7223950', name: 'Raccoon Point', flag: 'USA' },
      { mmsi: '367108940', imo: '7309338', name: 'Terrebonne Bay', flag: 'USA' },
      { mmsi: '367331190', imo: '7643497', name: 'Helge Hovland', flag: 'USA' },
      { mmsi: '367331210', imo: '7513379', name: 'Sea Bee', flag: 'USA' },
      { mmsi: '367331290', imo: '9010436', name: 'Gp Chauvin', flag: 'USA' },
      { mmsi: '367331320', imo: '9010412', name: 'Mermentau', flag: 'USA' },
      { mmsi: '367721230', imo: '7367031', name: 'F. Ray Rogers, Jr', flag: 'USA' },
      { mmsi: '367769530', imo: '8851651', name: 'Sea Wasp', flag: 'USA' },
      { mmsi: '367166240', imo: '8855578', name: 'Vasco Da Gama', flag: 'USA' },
      { mmsi: '367769550', imo: '7739507', name: 'Sea Charger', flag: 'USA' },
      { mmsi: '367769560', imo: '7943471', name: 'Frances T. Carinhas', flag: 'USA' },
      { mmsi: '367769570', imo: '8036263', name: 'Sea Wolf', flag: 'USA' },
      { mmsi: '366950060', imo: '7807469', name: 'Kittiwake', flag: 'USA' },
      { mmsi: '367772480', imo: '9010424', name: 'G. P. Amelia', flag: 'USA' },
      { mmsi: '367772730', name: 'Sea Falcon', flag: 'USA' },
      { mmsi: '367177980', imo: '7731244', name: 'Maria C', flag: 'USA' },
      { mmsi: '367772750', imo: '8024741', name: 'Lauren A', flag: 'USA' },
      { mmsi: '367016590', imo: '7613600', name: 'Mary Virginia', flag: 'USA' },
      { mmsi: '367772770', imo: '7609477', name: 'Mary Judith', flag: 'USA' },
      { mmsi: '367058853', imo: '7643679', name: 'Spt Protector', flag: 'USA' },
      { mmsi: '367508040', imo: '9260768', name: 'Ms Caroline', flag: 'USA' }
    ]
  },
  atlanticMenhaden: {
    id: 'atlantic-menhaden',
    name: 'Atlantic Menhaden Reduction Vessels',
    description: 'Factory ships grinding menhaden into fish meal and oil for export',
    color: '#EF4444',
    icon: '🏭',
    vessels: [
      { mmsi: '367108810', imo: '8201076', name: 'Calcasieu Pass', flag: 'USA' },
      { mmsi: '367108820', imo: '7309443', name: 'Tidelands', flag: 'USA' },
      { mmsi: '367163370', imo: '8942759', name: 'Smugglers Point', flag: 'USA' },
      { mmsi: '367558650', imo: '8115710', name: 'Rappahannock', flag: 'USA' },
      { mmsi: '367567290', imo: '7417276', name: 'Fleeton', flag: 'USA' },
      { mmsi: '367772250', imo: '8305511', name: 'Windmill Point', flag: 'USA' },
      { mmsi: '367772272', imo: '7807512', name: 'Cockrells Creek', flag: 'USA' },
      { mmsi: '367449880', imo: '7717054', name: 'Black Diver II', flag: 'USA' },
      { mmsi: '368302990', name: 'Reedville', flag: 'USA' }
    ]
  },
  atlanticHerring: {
    id: 'atlantic-herring',
    name: 'Atlantic Herring Mid-Water Trawlers',
    description: 'Industrial mid-water trawl vessels targeting Atlantic herring schools',
    color: '#3B82F6',
    icon: '🐟',
    vessels: [
      { mmsi: '366900670', imo: '8960098', name: 'Sunlight', flag: 'USA' },
      { mmsi: '366910520', imo: '8986626', name: 'Ranger', flag: 'USA' },
      { mmsi: '366953940', imo: '7731256', name: 'Starlight', flag: 'USA' },
      { mmsi: '366983070', imo: '8938564', name: 'Challenger', flag: 'USA' },
      { mmsi: '367016390', imo: '8687983', name: 'Dyrsten', flag: 'USA' },
      { mmsi: '367074460', imo: '7520425', name: 'Nashira', flag: 'USA' },
      { mmsi: '367160010', imo: '8501268', name: 'Endeavour', flag: 'USA' },
      { mmsi: '367324660', imo: '9010606', name: 'Retriever', flag: 'USA' },
      { mmsi: '367341030', imo: '8990744', name: 'Osprey', flag: 'USA' },
      { mmsi: '367346010', imo: '7230965', name: 'New Sea Rover', flag: 'USA' },
      { mmsi: '367394060', imo: '8704092', name: 'Relentless', flag: 'USA' },
      { mmsi: '367444970', imo: '8418021', name: 'Nordic Explorer', flag: 'USA' },
      { mmsi: '367650780', imo: '9731963', name: 'Araho', flag: 'USA' },
      { mmsi: '367658950', name: 'F/V Enterprise', flag: 'USA' },
      { mmsi: '367717970', imo: '8516421', name: 'Persistence', flag: 'USA' },
      { mmsi: '368065000', imo: '8943052', name: 'Providian', flag: 'USA' },
      { mmsi: '367747090', imo: '8680038', name: 'Mcdara', flag: 'USA' },
      { mmsi: '273296160', name: 'Nordic', flag: 'RUS' }
    ]
  }
}

// Helper function to get all vessel MMSIs for API queries
export const getAllVesselMMSIs = (groupIds = null) => {
  const groups = groupIds
    ? Object.values(vesselGroups).filter(g => groupIds.includes(g.id))
    : Object.values(vesselGroups)

  return groups.flatMap(group => group.vessels.map(v => v.mmsi))
}

// Helper function to get vessel by MMSI
export const getVesselByMMSI = (mmsi) => {
  for (const group of Object.values(vesselGroups)) {
    const vessel = group.vessels.find(v => v.mmsi === mmsi)
    if (vessel) {
      return { ...vessel, group: group.id, groupName: group.name, groupColor: group.color }
    }
  }
  return null
}
